export default __webpack_public_path__ + "static/for-hire-2-bcdbcbd45ad8e0c0c2d98d66b9141880.jpg";